import React, {Component} from 'react';
import '../App.css';
import '../css/all.css';



import UpperMenu from '../components/upper_menu/upper_menu.component'
import compose from '../utils/compose'
import withNofeshService  from '../hoc/withNofeshService.hoc';


class PolicyPage extends Component {

  unsubscribeService = null;








  componentDidMount = () => {

        // 1. receive data
        const { nofeshService } = this.props;
          
    }




  render() {         


    return (      
        <div>                                   
            <div className="hp_banner">
                <UpperMenu  
                      personData={this.props.personData} 
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}/>
            </div>
    
            <div className="hp_container">                                          
policy
                                
            </div>

            <div className="hp_footer">
            </div>
        </div>
    )
  }
}



export default compose(
    withNofeshService(),    
  )(PolicyPage);



